import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import PortfolioFilterBody from "./bodies/PortfolioFilterBody.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
export default {
  name: "PortfolioFilter",
  components: {
    FilterItem,
    PortfolioFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    portfolios: {
      type: Object,
      required: true
    },
    sellers: {
      type: Object,
      required: true
    },
    marketplaces: {
      type: Object,
      required: true
    }
  },
  computed: {
    getPortfolioTitle() {
      let joinedContents = this.portfolios.selected.map(el => el?.portfolio_name).join(", ");
      joinedContents = joinedContents.length > 0 ? joinedContents : 'Portfolios';
      return truncateString(joinedContents, 16);
    },
    getPortfolioSelectedTitle() {
      const joined = this.portfolios.selected.map(el => el?.portfolio_name).join(", ");
      return joined.length > 0 ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handlePortfolioSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.portfolios.searching = false;
      }
      this.portfolios.asyncSearch({
        keyword: value,
        args: {
          sellers: this.sellers.filterValues,
          sales_channel: this.marketplaces.filterValues
        }
      });
    },
    handleClear() {
      this.portfolios.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.portfolios.restoreSearch();
    },
    handleSelect({
      portfolio_id
    }) {
      this.portfolios.select({
        portfolio_id
      });
    },
    handleSelectOnly({
      portfolio_id
    }) {
      //console.log("Only", portfolio_id)
      this.portfolios.selectOnly({
        portfolio_id
      });
    },
    handleDeselect({
      portfolio_id
    }) {
      this.portfolios.deselect({
        portfolio_id
      });
      if (this.portfolios?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    handleClearAll() {
      this.portfolios.clear();
      this.$emit('cleared');
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.portfolios.clearDraft();
    },
    onHidden() {
      this.portfolios.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.portfolioFilterItem, initializer, callback);
    }
  }
};